import { PagesPermissions } from '../../../../models/Permissions/enum';

import {
  AccountingCenter,
  ApiDocs,
  Banks,
  CommodityMarketData,
  CompanyCenter,
  ComplianceCentre,
  CreateNewUser,
  Deal,
  DealContingentMarketData,
  Deals,
  DealsManagement,
  DebtCentre,
  DebtJournalEntries,
  DebtPricer,
  EntityPortfolio,
  FLCashConsumption,
  FundLevelAdmin,
  FundLevelCenter,
  FundSettlement,
  FxAnalysis,
  FxMarketData,
  GVOpportunities,
  HAAdmin,
  HairyChartAnalysis,
  HedgeAccounting,
  HedgeAccountingTradeItem,
  HedgeAccountingV2,
  HedgingCenter,
  Home,
  IrAnalysis,
  IrMarketData,
  JournalEntries,
  MarketCurvesCalculation,
  MarketDataAnalyzer,
  MarketDataCurves,
  MarketReports,
  NoAccess,
  NotFound,
  Pricers,
  Profile,
  PublicHolidayCalendar,
  Rebalancing,
  ReportCenter,
  RiskManagementAnalysis,
  RunDeliverables,
  ScheduledDeliverables,
  Settlements,
  SponsorDashboard,
  TermsAgreement,
  TermsPage,
  TotalCounterparties,
  TradeCenter,
  TradeNotification,
  TransactionCostAnalysis,
  TransactionDetail,
  TransactionRolling,
  Tutorials,
  UserRole,
  UsersPage,
  ValidationDashboard,
} from '../LazyPagesImport';
import SafeRoutePricer from '../SafeRoutePricer';

import { Route } from './types';

export const routes: { [key: string]: Route } = {
  home: {
    component: Home,
    url: '/home',
  },
  accountingCenter: {
    component: AccountingCenter,
    url: '/accounting-center',
    onOfPermission: [
      PagesPermissions.scheduledDeliverables,
      PagesPermissions.runDeliverables,
      PagesPermissions.hedgeAccounting,
      PagesPermissions.journalEntries,
    ],
  },
  scheduledDeliverables: {
    component: ScheduledDeliverables,
    url: '/scheduled-deliverables',
    permission: PagesPermissions.scheduledDeliverables,
  },
  runDeliverables: {
    component: RunDeliverables,
    url: '/run-deliverables',
    permission: PagesPermissions.runDeliverables,
  },
  hedgeAccounting: {
    component: HedgeAccounting,
    url: '/hedge-accounting',
    permission: PagesPermissions.hedgeAccounting,
  },
  hedgeAccountingV2: {
    component: HedgeAccountingV2,
    url: '/manage-hedge-accounting',
    permission: PagesPermissions.hedgeAccounting,
  },
  hedgeAccountingTrade: {
    component: HedgeAccountingTradeItem,
    url: '/manage-hedge-accounting/:tradeId?',
    permission: PagesPermissions.hedgeAccounting,
  },
  journalEntries: {
    component: JournalEntries,
    url: '/journal-entries',
    permission: PagesPermissions.journalEntries,
  },
  fundLevelCenter: {
    component: FundLevelCenter,
    url: '/fund-level-center',
    onOfPermission: [
      PagesPermissions.tradeNotification,
      PagesPermissions.complianceCentre,
      PagesPermissions.fundLevelAdmin,
      PagesPermissions.transactionRollingTool,
      PagesPermissions.exposureCapture,
      PagesPermissions.exposureCalculation,
      PagesPermissions.flCashConsumption,
    ],
  },
  tradeNotification: {
    component: TradeNotification,
    url: '/trade_notification',
    permission: PagesPermissions.tradeNotification,
  },
  complianceCentre: {
    component: ComplianceCentre,
    url: '/compliance-centre',
    permission: PagesPermissions.complianceCentre,
  },
  transactionRolling: {
    component: TransactionRolling,
    url: '/transaction-rolling',
    permission: PagesPermissions.transactionRollingTool,
  },
  fundLevelAdmin: {
    component: FundLevelAdmin,
    url: '/fund-level-admin',
    permission: PagesPermissions.fundLevelAdmin,
  },
  fundSettlement: {
    component: FundSettlement,
    url: '/fund-settlement',
    permission: PagesPermissions.settlements,
  },
  hedgingCenter: {
    component: HedgingCenter,
    url: '/hedging-center',
    onOfPermission: [
      PagesPermissions.irPricer,
      PagesPermissions.fxPricer,
      PagesPermissions.inflationPricer,
      PagesPermissions.commodityPricer,
      PagesPermissions.debtPricer,
    ],
  },
  pricers: {
    component: Pricers,
    componentRoute: SafeRoutePricer,
    url: '/hedging-center/pricer/:transactionId?',
    onOfPermission: [
      PagesPermissions.irPricer,
      PagesPermissions.fxPricer,
      PagesPermissions.inflationPricer,
      PagesPermissions.commodityPricer,
      PagesPermissions.debtPricer,
    ],
  },
  debtPricer: {
    component: DebtPricer,
    componentRoute: SafeRoutePricer,
    url: '/debt/pricer/:debtId?',
    permission: PagesPermissions.debtPricer,
  },
  marketCurvesCalculation: {
    component: MarketCurvesCalculation,
    url: '/market-curves-custom-calculations',
    permission: PagesPermissions.marketDataWidgetsPage,
  },
  irMarketData: {
    component: IrMarketData,
    url: '/ir-market-data',
    permission: PagesPermissions.irMarketData,
  },
  fxMarketData: {
    component: FxMarketData,
    url: '/fx-market-data',
    permission: PagesPermissions.fxForwardCurves,
  },
  commodityMarketData: {
    component: CommodityMarketData,
    url: '/commodity-market-data',
    permission: PagesPermissions.commodityMarketData,
  },
  marketReports: {
    component: MarketReports,
    url: '/market-reports',
    // permission: PagesPermissions.marketReportsPage,
  },
  marketDataCurves: {
    component: MarketDataCurves,
    url: '/market-data-curves',
    permission: PagesPermissions.marketDataCurvesPage,
  },
  marketDataAnalyzer: {
    component: MarketDataAnalyzer,
    url: '/pmca-ai-signal',
    permission: PagesPermissions.marketDataAI,
  },
  dealContingentMarketData: {
    component: DealContingentMarketData,
    url: '/deal-contingent-analysis',
    permission: PagesPermissions.irMarketData,
  },
  gvOpportunities: {
    component: GVOpportunities,
    url: '/gv-opportunities',
    permission: PagesPermissions.goldVisionOpportunities,
  },
  flCashConsumption: {
    component: FLCashConsumption,
    url: '/fund-level-center/fl-cash-consumption',
    permission: PagesPermissions.flCashConsumption,
  },
  riskManagementAnalysis: {
    component: RiskManagementAnalysis,
    url: '/risk-management-analysis',
    permission: PagesPermissions.riskManagementAnalysis,
  },
  hairyChartAnalysis: {
    component: HairyChartAnalysis,
    url: '/risk-management-analysis/hairy-chart',
    permission: PagesPermissions.hairyChart,
  },
  irAnalysis: {
    component: IrAnalysis,
    url: '/ir-analysis/:id?',
    permission: PagesPermissions.irAnalysis,
  },
  fxAnalysis: {
    component: FxAnalysis,
    url: '/fx-analysis',
    permission: PagesPermissions.riskManagementAnalysis,
  },
  tradeCenter: {
    component: TradeCenter,
    url: '/trade-center',
    permission: PagesPermissions.tradeCenter,
  },
  reportCenter: {
    component: ReportCenter,
    url: '/report-center',
    permission: PagesPermissions.reportCenter,
  },
  companyCenter: {
    component: CompanyCenter,
    url: '/company-center',
    permission: PagesPermissions.companyCenter,
  },
  debtCentre: {
    component: DebtCentre,
    url: '/debt-centre',
    permission: PagesPermissions.companyCenter,
  },
  debtJournalEntries: {
    component: DebtJournalEntries,
    url: '/debt-centre/journal-entries',
    permission: PagesPermissions.companyCenter,
  },
  banks: {
    component: Banks,
    url: '/banks',
    permission: PagesPermissions.banks,
  },
  totalCounterparties: {
    component: TotalCounterparties,
    url: '/total-counterparties',
    permission: PagesPermissions.counterpartiesPage,
  },
  deals: {
    component: Deals,
    url: '/deals',
    permission: PagesPermissions.deals,
  },
  dealsManagement: {
    component: DealsManagement,
    url: '/deals-management',
    permission: PagesPermissions.dealsManagement,
  },
  deal: {
    component: Deal,
    url: '/deal/:goldVisionId?',
    permission: PagesPermissions.deals,
  },
  transactionCostAnalysis: {
    component: TransactionCostAnalysis,
    url: '/transaction-cost-analysis',
    permission: PagesPermissions.transactionCostAnalysis,
  },
  haAdmin: {
    component: HAAdmin,
    url: '/ha-admin',
    permission: PagesPermissions.haAdministration,
  },
  transactionDetail: {
    component: TransactionDetail,
    url: '/portfolio/transaction/:transactionId?',
    permission: PagesPermissions.transactionDetail,
  },
  termsAgreement: {
    component: TermsAgreement,
    url: '/terms-agreement',
  },
  terms: {
    component: TermsPage,
    url: '/terms',
  },
  entityPortfolio: {
    component: EntityPortfolio,
    url: '/portfolio/entity/:entityId',
    permission: PagesPermissions.entityPortfolio,
  },
  validationDashboard: {
    component: ValidationDashboard,
    url: '/validation-dashboard/:entityId',
  },
  userRole: {
    component: UserRole,
    url: '/user-role',
    permission: PagesPermissions.manageAccessControl,
  },
  users: {
    component: UsersPage,
    url: '/users',
    permission: PagesPermissions.users,
  },
  userProfile: {
    component: Profile,
    url: '/profile/:userId?/:isNew?',
    permission: PagesPermissions.userProfile,
  },
  settlement: {
    component: Settlements,
    url: '/settlements',
    permission: PagesPermissions.settlements,
  },
  sponsorDashboard: {
    component: SponsorDashboard,
    url: '/sponsor-dashboard',
    permission: PagesPermissions.sponsorPage,
  },
  createUser: {
    component: CreateNewUser,
    url: '/create-user',
    permission: PagesPermissions.createNewUser,
  },
  rebalancing: {
    component: Rebalancing,
    url: '/fund-level-center/rebalancing',
    permission: PagesPermissions.exposureCapture,
  },
  noAccess: {
    component: NoAccess,
    url: '/no-access',
  },
  notFound: {
    component: NotFound,
    url: '/404',
  },
  tutorials: {
    component: Tutorials,
    url: '/tutorials',
  },
  apiDocs: {
    component: ApiDocs,
    url: '/api-docs/:apiId?',
    permission: PagesPermissions.clientApiDocs,
  },
  publicHolidayCalendar: {
    component: PublicHolidayCalendar,
    url: '/public-holiday-calendar',
    permission: PagesPermissions.publicHolidayCalendar,
  },
  allOtherUrl: {
    component: NotFound,
    url: '*',
  },
};
